var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vab-layout-common",class:{fixed: _vm.fixedHeader, 'no-tabs-bar': !_vm.showTabs,}},[_c('div',{staticClass:"vab-layout-header",class:{
      'fixed-header': _vm.fixedHeader,
    }},[_c('bd-header',{attrs:{"layout":"common"}}),(_vm.routePath === '/guidePage' || _vm.routePath === '/newsMore' ? false : true )?_c('div',[_c('side-bar',{attrs:{"layout":"common"}})],1):_vm._e()],1),_c('div',{staticClass:"vab-main main-padding",class:{
      'is-collapse-main': _vm.collapse,
    },style:({marginLeft: (_vm.routePath === "/guidePage" || _vm.routePath === "/newsMore") ? "0" : (_vm.collapse ? "64px" : "235px")})},[_c('app-main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }